import React from 'react';
import { TableHead, TableRow, useMediaQuery, useTheme } from '@mui/material';
import { HeaderCell, StrikeHeaderCell } from './OptionTableCell';

const TableHeader = ({ callHeaders, putHeaders }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  // For mobile, only keep the LTP column in a simplified 3-column layout
  // For desktop, show all columns
  const filteredCallHeaders = isMobile 
    ? callHeaders.filter(header => ['ltp'].includes(header.toLowerCase()))
    : callHeaders;
  
  const filteredPutHeaders = isMobile 
    ? putHeaders.filter(header => ['ltp'].includes(header.toLowerCase()))
    : putHeaders;
  
  // Simplified header display labels
  const getHeaderLabel = (header) => {
    const headerLower = header.toLowerCase();
    
    // Always use LTP label for both mobile and desktop
    if (headerLower === 'ltp') return 'LTP';
    
    if (headerLower === 'change%') return 'Change %';
    if (headerLower === 'oi') return 'OI';
    if (headerLower === 'volume') return 'Volume';
    
    return header.toUpperCase();
  };
  
  return (
    <TableHead sx={{ width: '100%' }}>
      <TableRow sx={{ 
        display: isMobile ? 'flex' : 'table-row',
        width: '100%'
      }}>
        {/* Call Headers */}
        {filteredCallHeaders.map((header, i) => (
          <HeaderCell 
            key={`call-header-${i}`} 
            header={getHeaderLabel(header)} 
            side="ce" 
          />
        ))}
        
        {/* Strike Header */}
        <StrikeHeaderCell />
        
        {/* Put Headers */}
        {filteredPutHeaders.map((header, i) => {
          const headerLower = header.toLowerCase();
          return (
            <HeaderCell 
              key={`put-header-${i}`} 
              header={getHeaderLabel(header)} 
              side="pe" 
            />
          );
        })}
      </TableRow>
    </TableHead>
  );
};

export default TableHeader; 